import { oz } from '@weft/utils';

export const SYSTEM_EVENT_TYPES = {
  INVOICE_CREATED: 'INVOICE_CREATED',
  INVOICE_APPROVED: 'INVOICE_APPROVED',
  INVOICE_PAID: 'INVOICE_PAID',
} as const;

export type SystemEventType = typeof SYSTEM_EVENT_TYPES[keyof typeof SYSTEM_EVENT_TYPES];

export const SystemEventTypesSchema = oz.nativeEnum(SYSTEM_EVENT_TYPES).openapi('SystemEventType');